import { useEffect, useRef } from 'react';

import { captureException } from '@sentry/react';

export function useCallbackWhenDomChanges(
  callback: () => void,
  enabled = true,
  // null is accepted for convenience - should use body in this case
  root: HTMLElement | null = window.document.body
) {
  const callbackRef = useRef<() => void>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const observer = new MutationObserver(() => {
      try {
        callbackRef.current();
      } catch (e) {
        console.error(e);
        captureException(e);
      }
    });

    observer.observe(root ?? window.document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [enabled, root]);
}
